import InformationDesignBackground from "url:./assets/infodes.gif";
import Pattern from "url:./assets/pattern.png";
import FoodDeliveryAppDemo from "url:./assets/NonVegMart.qt";
import RealEstateCRMDemo from "url:./assets/RealEstate.mp4";
import SalonAppScreenshot from "url:./assets/salon.png";
import CourierServicesScreenshot from "url:./assets/courierServices.png";

export type LINK_DETAILS_ANIMATE = {
  fromLeft?: React.FunctionComponent;
  fromRight?: React.FunctionComponent;
  theme?: {
    screenRecording?: React.CSSProperties;
    background?: React.CSSProperties;
    text?: React.CSSProperties;
    animation?: React.CSSProperties;
    isDarkArrow?: boolean;
  };
};

export type LINK_DETAILS = {
  title: string;
  id: string;
  animate?: LINK_DETAILS_ANIMATE;
};

export enum LINK_SECTION {
  UI_UX_DESIGN_PROJECTS = 1,
  FRAMES_FORMS = 2,
}

const defaultTheme: LINK_DETAILS_ANIMATE = {
  theme: {
    background: {
      background: "#FFF",
    },
    text: {
      color: "#212121",
    },
    isDarkArrow: false,
  },
};

const defaultThemeDark: LINK_DETAILS_ANIMATE = {
  theme: {
    background: {
      background: "#212121",
    },
    text: {
      color: "#FFF",
    },
    isDarkArrow: true,
  },
};

export const ALL_LINKS: Record<LINK_SECTION, LINK_DETAILS[]> = {
  [LINK_SECTION.UI_UX_DESIGN_PROJECTS]: [
    {
      title: "Food Delivery App",
      id: "ui-ux-0",
      animate: {
        fromLeft: () => (
          <div style={{ width: "300px", left: "50%" }}>
            <video
              src={FoodDeliveryAppDemo}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              style={{ width: "100%", borderRadius: 50 }}
            />
          </div>
        ),
        theme: {
          background: { background: "#FFDDDA" },
          text: { color: "#212121" },
          isDarkArrow: false,
        },
      },
    },
    {
      title: "Design System",
      id: "ui-ux-2",
      animate: {
        fromLeft: () => (
          <div className="btn-animation flex flex-col gap-4">
            <button disabled type="button" className="b1">Default</button>
            <button disabled type="button" className="b2">Hover</button>
            <button disabled type="button" className="b3">Action</button>
            <button disabled type="button" className="b4">Inactive</button>
          </div>
        ),
        theme: {
          background: {
            background: `#000 url(${Pattern}) center / cover no-repeat`,
          },
          text: {
            color: "#FFF",
          },
          isDarkArrow: true,
        },
      },
    },
    {
      title: "Real Estate System",
      id: "ui-ux-3",
      animate: {
        fromLeft: () => (
          <div style={{ width: "300px", left: "50%" }}>
            <video
              src={RealEstateCRMDemo}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              style={{ width: "100%", borderRadius: 50 }}
            />
          </div>
        ),
        theme: {
          background: { background: "#FFC65C" },
          text: { color: "#212121" },
          isDarkArrow: false,
        },
      },
    },
    {
      title: "Courier Services",
      id: "ui-ux-4",
      animate: {
        fromLeft: () => (
          <div style={{ width: "100%", left: "50%" }}>
            <img
              src={CourierServicesScreenshot}
              alt="Courier Services app screenshot"
            />
          </div>
        ),
        ...defaultThemeDark,
      },
    },
    {
      title: "Information Design",
      id: "ui-ux-5",
      animate: {
        theme: {
          background: {
            background:
              `linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.9)), #000 url(${InformationDesignBackground}) center / auto repeat`,
          },
          text: {
            color: "#FFF",
          },
          isDarkArrow: true,
        },
      },
    },
    {
      title: "Salon Service App",
      id: "ui-ux-6",
      animate: {
        fromLeft: () => (
          <div style={{ width: "300px", left: "50%" }}>
            <img src={SalonAppScreenshot} alt="Salon app screenshot" />
          </div>
        ),
        theme: {
          background: { background: "#777" },
          text: { color: "#FFF" },
          isDarkArrow: true,
        },
      },
    },
    {
      title: "Interaction Design",
      id: "ui-ux-1",
      animate: {
        fromLeft: () => <div></div>,
        ...defaultThemeDark,
      },
    },
  ],
  [LINK_SECTION.FRAMES_FORMS]: [
    {
      title: "Graphic Design",
      id: "ff-1",
      animate: {
        ...defaultTheme,
      },
    },
    {
      title: "Sketches",
      id: "ff-2",
      animate: {
        ...defaultTheme,
      },
    },
    {
      title: "Photography",
      id: "ff-3",
      animate: { ...defaultThemeDark },
    },
  ],
};
